/**
 * What the donations page may offer to refund (docs/Decisions.md D58). The
 * API (src/services/billing/refunds.js `refundability`) is the authority and
 * re-checks every refund; this keeps the button and the amount box honest.
 */

export const REFUND_WINDOW_DAYS = 180;
const REFUNDABLE = ['succeeded', 'partially_refunded'];

/** Cents left to refund on a ledger row. */
export function refundableCents(donation) {
  const total = donation?.amounts?.totalCents ?? 0;
  const refunded = Number.isInteger(donation?.refundedCents) ? donation.refundedCents : 0;
  return Math.max(total - refunded, 0);
}

/** Whether the row can be refunded now. */
export function canRefund(donation, now = Date.now()) {
  if (!donation || !REFUNDABLE.includes(donation.status)) return false;
  if (refundableCents(donation) === 0) return false;
  const age = now - new Date(donation.createdAt).getTime();
  return Number.isFinite(age) && age <= REFUND_WINDOW_DAYS * 24 * 60 * 60 * 1000;
}
